import { prefixLink, REGION } from '@ms/config/app'
import { useState } from '@ms/utils/useState'
import { getAdInfo } from 'wap/common/api'

const KEY_FIRST_NAVS = 'first-navs'
export const FIRST_NAVS_SPOT_ID = 'HomeFirstclassNavicon'

const navHome = {
  href: prefixLink(),
  text: 'Home',
  name: 'home'
}

const mockList = [
  navHome,
  {
    href: prefixLink('/sports/soccer/live_matches'),
    name: 'live',
    text: 'Live'
    // image: ''
  },
  {
    href: prefixLink('/sports'),
    name: 'sports',
    text: 'Sports'
  },
  {
    href: prefixLink('/virtual'),
    name: 'virtuals',
    text: 'Virtuals'
    // image: ''
  },
  {
    href: prefixLink('/games'),
    name: 'games',
    text: 'Games',
    exclude: REGION === 'zm'
    // image: ''
  },
  {
    href: prefixLink('/jackpot'),
    name: 'jackpot',
    text: 'Jackpot'
    // image: ''
  }
]

const parseFirstNavs = (list = []) => {
  if (list && list.length) {
    // home 首页常驻，不用配置
    const navlist = list.map((x) => {
      const { flagText, href, image, text, name = '' } = x
      return { flagText, href, image, text, name }
    })
    return [navHome, ...navlist]
  } else {
    return mockList.filter((x) => !x.exclude)
  }
}

export default function useFirstNavs() {
  const fetchData = async () => {
    try {
      const data = await getAdInfo([FIRST_NAVS_SPOT_ID])
      const ads = data[0]?.ads || []
      return { data: parseFirstNavs(ads) }
    } catch (error) {
      console.error(error)
      return { data: parseFirstNavs() }
    }
  }

  const { state: firstNavs, setState, request: fetchFirstNavs } = useState([], { cacheKey: KEY_FIRST_NAVS, fetchData })

  const setFirstNavs = (list = []) => {
    setState(parseFirstNavs(list))
  }

  return {
    firstNavs,
    fetchFirstNavs,
    setFirstNavs
  }
}
